import React from "react";
import { useAuth } from "../../contexts/auth.context";
import {
  Layout,
  Avatar,
  Typography,
  Space,
  Dropdown,
  Menu,
  Button,
  Tooltip,
} from "antd";
import {
  UserOutlined,
  LogoutOutlined,
  BulbOutlined,
  BulbFilled,
  SettingOutlined,
  DollarOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useExchangeRate } from "../../contexts/exchangeRate.context";
import NotificationBell from "../NotificationBell/notificationBell.component";

const { Header: AntHeader } = Layout;
const { Title, Text } = Typography;

export default function Header({
  darkTheme,
  toggleTheme,
  onOpenCommandPalette,
}: {
  darkTheme: boolean;
  toggleTheme: () => void;
  onOpenCommandPalette?: () => void;
}) {
  const { authState, onLogout } = useAuth();
  const { exchangeRate, showExchangeRateModal } = useExchangeRate();
  const navigate = useNavigate();
  const { name, role } = authState?.user || {};

  const headerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 20px",
    backgroundColor: darkTheme ? "#001529" : "#fff",
    color: darkTheme ? "#fff" : "#000",
    borderRadius: 8,
    boxShadow: darkTheme
      ? "0px 2px 8px rgba(0, 0, 0, 0.3)"
      : "0px 2px 8px rgba(0, 0, 0, 0.1)",
  };

  const titleStyle = {
    margin: 0,
    color: darkTheme ? "#fff" : "#000",
  };

  const textStyle = {
    color: darkTheme ? "#fff" : "#000",
    fontWeight: 500,
  };

  const handleLogout = () => {
    onLogout();
    navigate("/login");
  };

  const userMenu = (
    <Menu
      items={[
        {
          key: "profile",
          label: "Профиль",
          icon: <SettingOutlined />,
          onClick: () => navigate("/profile"),
        },
        {
          key: "logout",
          label: "Выход",
          icon: <LogoutOutlined />,
          onClick: handleLogout,
        },
      ]}
    />
  );

  return (
    <AntHeader style={headerStyle}>
      <Title level={3} style={titleStyle}>
        Factory
      </Title>

      <Space size="middle">
        <NotificationBell />
        
        {onOpenCommandPalette && (
          <Tooltip title="Поиск (Ctrl/Cmd + K)">
            <Button
              icon={<SearchOutlined />}
              type="text"
              onClick={onOpenCommandPalette}
              style={{ color: darkTheme ? "#fff" : "#000" }}
            >
              Поиск
            </Button>
          </Tooltip>
        )}
        
        <Button
          icon={
            darkTheme ? (
              <BulbFilled style={{ color: "#ffd700" }} />
            ) : (
              <BulbOutlined />
            )
          }
          type="text"
          onClick={toggleTheme}
        />

        <Button
          type="text"
          icon={<DollarOutlined />}
          onClick={showExchangeRateModal}
          style={{ color: darkTheme ? "#fff" : "#000" }}
        >
          {exchangeRate ? `1 USD = ${exchangeRate.toFixed(2)} TJS` : "Set Rate"}
        </Button>

        <Dropdown
          overlay={userMenu}
          placement="bottomRight"
          trigger={["click"]}
        >
          <Space>
            <Avatar icon={<UserOutlined />} />
            <Text style={textStyle}>
              {name} ({role})
            </Text>
          </Space>
        </Dropdown>
      </Space>
    </AntHeader>
  );
}
